<template>
  <div class="boox-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.k">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="boox"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('boox.title2')" prop="title">
            <el-input
              v-model="boox.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('boox.region')" prop="region">
            <el-radio-group v-model="boox.region">
              <el-radio label="1">国内</el-radio>
              <el-radio label="2">国外</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item :label="$t('boox.file')" prop="file">
            <div>
              <p v-if="fileName">{{ fileName }}</p>
              <div v-if="isSave">
                <el-progress
                  class="boox-upload-progress"
                  :percentage="progress"
                  color="#BF735B"
                ></el-progress>
                <span>（正在上传中,请不要退出当前界面）</span>
              </div>
            </div>
            <el-upload
              v-if="!isSave"
              action
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleAvatarChange"
            >
              <el-button :disabled="isSave" size="small" type="primary"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>

          <el-form-item label="语言组" prop="langGroups">
            <el-checkbox-group v-model="boox.langGroups" @change="selectLangs">
              <el-checkbox
                v-for="item in langData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="当前语言">
            <p>{{ langs.join("、") }}</p>
          </el-form-item>

          <el-form-item label="型号选择">
            <div class="manualGroups-checkbox">
              <template v-for="item in categoryData">
                <div
                  class="manualGroups-checkbox-item"
                  :key="item._id"
                  v-if="item.models.length"
                >
                  <div class="manualGroups-checkbox-allchecke">
                    <i
                      class="el-icon-caret-right"
                      @click.stop="item.showChildren = !item.showChildren"
                    ></i>
                    <el-checkbox
                      :indeterminate="item.isIndeterminate"
                      v-model="item.checkAll"
                      @change="handleCheckAllChange(item)"
                      >{{ item.name }}
                    </el-checkbox>
                  </div>
                  <!-- <div style="margin: 15px 0;"></div> -->
                  <el-collapse-transition>
                    <el-checkbox-group
                      v-if="item.showChildren"
                      class="manualGroups-checkbox-children"
                      v-model="item.checkedModel"
                      @change="handleCheckedCitiesChange(item)"
                    >
                      <el-checkbox
                        v-for="(model, index) in item.models"
                        :label="model.model"
                        :key="index"
                        >{{ model.model }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-collapse-transition>
                </div>
              </template>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OSS from "ali-oss";

export default {
  computed: {
    ...mapGetters(["buckets"]),
  },
  data() {
    return {
      boox: {
        title: "",
        description: "",
        public: 1,
        type: "manual",
        langGroups: [],
        model: this.$route.query.model || "",
      },
      isSave: false,
      progress: 0,
      fileItem: null,
      langs: [],
      fileName: "",
      rules: {
        title: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur",
          },
        ],
      },
      categoryData: [],
      langData: [],
    };
  },
  methods: {
    hasModels(item) {
      let arr = [];
      if (this.$route.query.k) {
        for (let ele of item.models) {
          if (this.boox.models.includes(ele.model)) {
            arr = [...arr, ele.model];
          }
        }
      }
      return arr;
    },
    getLangGroups() {
      this.$http.getLangGroups().then((res) => {
        this.langData = res.data.results;
        this.selectLangs();
      });
    },
    getManualGroups() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getManualGroups({
            limit: 10000,
            page: 1,
          });

          for (let item of res.data.results) {
            item.checkedModel = this.hasModels(item);
            item.showChildren = item.checkedModel.length > 0;
            item.checkAll = item.checkedModel.length === item.models.length;
            item.isIndeterminate =
              item.checkedModel.length > 0 &&
              item.checkedModel.length < item.models.length;
          }
          this.categoryData = res.data.results;
          if (!this.categoryData.length) return;
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    handleCheckAllChange(item) {
      item.checkedModel = item.checkAll
        ? item.models.map((item) => item.model)
        : [];
      item.isIndeterminate = false;
    },

    handleCheckedCitiesChange(item) {
      item.checkAll = item.checkedModel.length === item.models.length;
      item.isIndeterminate =
        item.checkedModel.length > 0 &&
        item.checkedModel.length < item.models.length;
    },

    handleAvatarChange(file) {
      this.fileItem = file;
      this.fileName = file.name;
    },
    getManualFileDetails() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getManualFileDetails({
            file: this.$route.query.k,
          });
          this.boox = Object.assign({}, res.data);
          this.fileName = res.data.file.name;
          resolve("");
        } catch (error) {
          reject(error);
        }
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.k) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    getModels() {
      let models = [];
      for (let item of this.categoryData) {
        models = [
          ...models,
          ...item.models.filter((ele) => item.checkedModel.includes(ele.model)),
        ];
      }
      return models;
    },

    selectLangs() {
      let arr = [];
      for (let item of this.boox.langGroups) {
        arr.push(this.langData.find((ele) => ele._id === item));
      }
      this.langs = [];
      for (let item of arr) {
        this.langs = [...this.langs, ...item.langs];
      }
      this.langs = this.$_.uniq(this.$_.flattenDeep(this.langs));
    },

    async create() {
      if (!this.fileItem) {
        this.elMsg(this.$t("请添加文件"), "warning");
        return;
      }
      let bucket = this.buckets["onyx-static"].bucket;
      this.isSave = true;
      let fileObj = await this.uploadOss(this.fileItem, bucket, "manual");
      this.boox.file = fileObj;
      this.boox.type = "manual";
      this.boox.model = this.$route.query.model;
      this.boox.models = this.getModels();
      await this.$http.createManualFile(this.boox);
      this.elMsg(this.$t("alertMsg.addSuccess"), "success");
      this.$router.back();
    },

    async edit() {
      let fileObj = null;
      if (this.fileItem) {
        let bucket = this.buckets["onyx-static"].bucket;
        this.isSave = true;
        fileObj = await this.uploadOss(this.fileItem, bucket, "manual");
        await this.$http.replaceManualFile({
          file: fileObj,
          oldFileKey: this.$route.query.k,
        });
      }
      let params = {
        file: fileObj ? fileObj.key : this.$route.query.k,
        title: this.boox.title,
        models: this.getModels(),
        langGroups: this.boox.langGroups,
      };
      this.$http.updateManualFile(params).then((res) => {
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        this.$router.back();
      });
    },

    uploadOss(file, bucket, key) {
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let region = this.buckets["onyx-static"].region;
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket,
            secure: true,
          });
          let coverData = await client.multipartUpload(
            `${key}/${file.name}`,
            file.raw,
            {
              progress: (p, cpt, res) => {
                this.progress = Number((p * 100).toFixed(2));
              },
            }
          );

          resolve({
            key: coverData.name,
            bucket,
            name: file.name,
            url: coverData.res.requestUrls[0].split("?")[0],
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  async mounted() {
    if (this.$route.query.k) {
      await this.getManualFileDetails();
    }
    this.getLangGroups();
    this.getManualGroups();
  },
};
</script>

<style lang="scss">
.boox-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .boox-import-btn {
        margin-top: 10px;
      }
      .boox-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
      .manualGroups-checkbox {
        .manualGroups-checkbox-item + .manualGroups-checkbox-item {
          margin-top: 10px;
        }
        .manualGroups-checkbox-allchecke {
          /* font-size: 20px; */
          > i {
            padding: 4px;
            cursor: pointer;
            /* margin-left: 5px; */
          }
        }
        .manualGroups-checkbox-children {
          padding-left: 44px;
        }
      }
    }
  }
}
</style>
